export default defineNuxtRouteMiddleware(async (to, from) => {
  if (from.query.sid && !to.query.sid) {
    return navigateTo({
      path: to.path,
      query: { ...to.query, sid: from.query.sid },
    });
  }
});
